<style lang="scss" scoped>

.error {    
    background: #D63939;
}

.deactivated {
    background-color: #DDDDDD; background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAF0lEQVQIW2NkQAP////3YaRQEGQGuhEAFpIQc5htOmUAAAAASUVORK5CYII=);
}

.link-active {
    text-decoration: none ! important;
    cursor: pointer;
}

.link-inactive {
    text-decoration: none ! important;
    cursor: default;
}

</style>

<template>    
    <div class="row align-items-center background-error" @click.stop="$emit('selectSensor', sensor)">
        <div class="col-auto" :class="[isErrors ? 'link-active': 'link-inactive']" @click.stop="isErrors ? showErrors(): null" >
            <span class="avatar text-white bg-blue" :class="[ !sensor.isImportActive ? 'deactivated' : isErrors ? 'error': '']">
               <span class="badge" :class="[isErrors ? 'bg-red': (!sensor.isImportActive ? 'bg-grey': 'bg-green')]" ></span>
               <svg v-if="sensor.parameterId == 'n'" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z" /></svg>
               <svg v-else-if="sensor.parameterId == 'e'" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                </svg>
            </span>
        </div>
        <div class="col text-truncate background-error link-active" :class="[isErrors ? 'link-active': 'link-inactive']" @click.stop="isErrors ? showErrors(): null" >
            <span class="text-body d-block">
                {{ sensor.label }} ({{ sensor.labelParameter }})
            </span>
            <span v-if="sensor.isOwnSensor" class="text-body d-block">
                <small v-if="sensor.sharedUserIds.length > 0" class="d-block text-muted text-truncate mt-n1">
                    Geteilt mit
                    <span v-for="(sharedUserId, index) in sensor.sharedUserIds" :key="sharedUserId">
                        {{ sharedUserId }}<span v-if="index < sensor.sharedUserIds.length - 1">, </span>
                    </span>
                </small>
                <small v-else class="d-block text-muted text-truncate mt-n1">
                    Sensordaten nicht mit anderen Nutzern geteilt
                </small>
            </span>
            <span v-else class="text-body d-block">
                <small class="d-block text-muted text-truncate mt-n1">
                    Sensor von {{ sensor.userId }} zur Verfügung gestellt
                </small>
            </span>
            
            <span class="text-body d-block">
                <small class="d-block text-muted text-truncate mt-n1">
                    <span>
                        {{ sensor.sensorDataYears ? 'Daten: ' + sensor.sensorDataYears.join(', ') + ' -' : ''}}
                        Letzte Aktualisierung: {{ formatDateTime(sensor.lastUpdate, 'DD.MM.YYYY HH:mm') }}
                    </span>
                    <span v-if="sensor.isUsed && sensor.isOwnSensor">
                        - Sensordaten verwendet
                    </span>
                    <span v-else-if="sensor.isOwnSensor" >
                        - Sensordaten nicht verwendet
                    </span>
                </small>
            </span>
        </div>
        <div v-show="!sensor.isImportActive" class="col-auto">
            <div class="list-group-item-actions show" title="Sensordatenimport deaktiviert">
               <svg xmlns="http://www.w3.org/2000/svg" class="text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M3.05 11a8.975 8.975 0 0 1 2.54 -5.403m2.314 -1.697a9 9 0 0 1 12.113 12.112m-1.695 2.312a9 9 0 0 1 -14.772 -3.324m-.5 5v-5h5" />
                  <path d="M3 3l18 18" />
                </svg>
            </div>
        </div>
        <div v-show="isErrors" class="col-auto">
            <div class="list-group-item-actions show link-active" title="Sensorfehler anzeigen" @click.stop="showErrors">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-red" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                    <path d="M10 20h-6" />
                    <path d="M14 20h6" />
                    <path d="M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z" />
                    <path d="M12 6v2" />
                    <path d="M12 11v.01" />
                </svg>
            </div>
        </div>
        <div v-show="isRemovable" class="col-auto">
            <div class="list-group-item-actions show link-active" title="Sensor Entfernen" @click.stop="$emit('removeSensor', sensor)" >
                <svg xmlns="http://www.w3.org/2000/svg" class="text-blue" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z" />
                    <path d="M12 10l4 4m0 -4l-4 4" />
                </svg>
            </div>
        </div>
        <div v-show="isAdjustable && sensor.isOwnSensor" class="col-auto">
            <div class="list-group-item-actions show link-active" title="Sensor einstellen" @click.stop="$emit('adjustSensor', sensor)" >
                <svg xmlns="http://www.w3.org/2000/svg" class="text-blue" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                    <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                </svg>
            </div>
        </div>
    </div>
    <Alert type="danger" :show="alertErrors" class="mt-3 mb-1 ms-0" @click="hideErrors">
        <template v-slot:title>Sensorfehler aufgetreten</template>
        <ul class="mb-0">
            <li v-for="error in sensor.errors" :key="error">
                {{ error }}  
            </li>
        </ul>
    </Alert>
</template>

<script>

import * as dayjs from 'dayjs';
import Alert from '@/components/Alert.vue';

export default {
    name: 'SensorItem',
    inject: [
        'state',
        'config'
    ],
    components: {
        Alert
    },
    emits: [
        'selectSensor', 
        'removeSensor', 
        'adjustSensor'
    ],
    props: {
        sensor: {
            type: Object,
            default: null
        },
        isSelectable: {
            type: Boolean,
            default: false
        },
        isRemovable: {
            type: Boolean,
            default: false
        },
        isAdjustable: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            alertErrors: false,
        }
    },
    computed: {
        isErrors : function() {
            if (this.sensor.errors && Array.isArray(this.sensor.errors) && this.sensor.errors.length > 0) {
                return true;
            } 
            return false;
        }
    },
    methods: {
        getShortLabel: function (label) {
            return label.substring(0,2);
        },
        showErrors: function () {
            if (this.isErrors === true && this.alertErrors === false) {
                this.alertErrors = true;
            } else {
                this.alertErrors = false;
            }
        },
        hideErrors: function () {
           this.alertErrors = false;
        },
        formatDateTime: function (date, format) {
            return dayjs(date).format(format);
        }
    },
	watch: {        
        
    }
}
</script>